:root:root:root:root .tamagui-input-no-outline:focus-visible {
  outline-width: 0 !important;
  border-width: 0 !important;
}
